<template>
    <div class="ObjectGroupListPage">
        <ObjectListHeaderPanel/>
        <div class="container">
            <div class="ObjectGroupListPage__list" v-if="list.length">
                <div class="ObjectGroupListPage__group" v-for="({title, objects}, index) of pageObjects" :key="index">
                    <ObjectGroup :objects="objects" :title="title"/>
                </div>
            </div>
            <Pagination
                    v-if="pageCount > 1"
                    :page-count="pageCount"
                    v-model="currentPage"
            />
        </div>
        <Footer/>
    </div>
</template>

<script>
import ObjectListHeaderPanel from "@/components/ObjectListHeaderPanel";
import {mapGetters} from "vuex";
import ObjectGroup from "@/components/Object/ObjectGroup";
import Pagination from "@/components/Pagination";
import paginationObjects from "@/mixins/paginationObjects";
import Footer from "@/components/Footer";

export default {
    name: "ObjectGroupListPage",
    components: {
        ObjectListHeaderPanel,
        ObjectGroup,
        Pagination,
        Footer,
    },
    mixins: [paginationObjects(6)],
    computed: {
        list() {
            return this.getGrouped ?? [];
            /*return [
                {
                    title: 'Поселок Жуковка-2',
                    objects: this.filteredAndSortingObjects
                }
            ]*/
        },
        ...mapGetters(['filteredAndSortingObjects', 'getGrouped'])
    }
}
</script>

<style lang="scss">
.ObjectGroupListPage {

  &__list {
    margin-bottom: 40px;
  }

}
</style>